import type { CaseType } from "./deriveCaseType";

export function allowsZeroTechnicalMaterial(
  caseType?: CaseType | null
): boolean {
  return caseType === "grossing_only";
}

export function resolveAccessioningBlockCount(
  caseType: CaseType | null | undefined,
  blockCount: unknown
): number {
  if (allowsZeroTechnicalMaterial(caseType)) return 0;
  return Number(blockCount) || 1;
}
